import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { AppIconButton } from '@client/foundation/design-system/components';

interface FormArrayItemProps {
  children: ReactNode;
  onRemove: (index: number) => void;
  index: number;
  disableRemove?: boolean;
}

export const FormArrayItem: React.FC<FormArrayItemProps> = ({
  children,
  onRemove,
  index,
  disableRemove = false
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {children}

      <AppIconButton
        title="Delete"
        tone="danger"
        disabled={disableRemove}
        onClick={() => onRemove(index)}
        sx={{
          ml: 1,
          mr: -0.7
        }}
      >
        <DeleteIcon />
      </AppIconButton>
    </Box>
  );
};
